export const INFURA_URL=process.env.VUE_APP_INFURA_URL;
export const VALUE_PRE_NFT = 0.069;
export const VALUE_ETH = 0.08;
export const TOTAL_TOKENS = 10010;
export const TOASTER_OPTIONS = { position: 'bottom', duration: 2000 };
export const DISCORD_URL = 'https://discord.gg/ZThG6tFDSc';
export const TWITTER_URL = 'https://twitter.com/WereWolfValley';